// import Vue from "vue"
// import Router from "vue-router"
// import GalleryView from "./views/Gallery.vue"

// Vue.use(Router)

// export default new Router({
//   mode: "hash",
//   routes: [
//     {
//       path: "/gallery/:id?",
//       name: "gallery",
//       component: GalleryView,
//     },
//     {
//       path: "*",
//       redirect: "/gallery",
//     },
//   ],
// })

import Vue from "vue"
import Router from "vue-router"
import GalleryView from "./views/Gallery.vue"

Vue.use(Router)

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/gallery/:id?",
      name: "gallery",
      component: GalleryView,
    },
    {
      path: "*",
      redirect: "/gallery",
    },
  ],
})
